import React from "react";
import LoginPage from "./LoginPage";
import './App.css';

function App() {
  return <LoginPage />;
}

export default App;

